<template>
    <div>
        <div class="blockcontent" v-if="b.acf_fc_layout==='text'" v-html="b.text" :style="{marginTop: `${b.abstand_oben||100}px`}">
        </div>
        <div class="image" v-if="b.acf_fc_layout==='bild'"
             :class="b.ausrichtung" :style="{marginTop: `${b.abstand_oben}px`}">
            <img :src="b.bild.sizes.large" alt="" v-if="b.ausrichtung==='full'" class="full" :class="{'shadowed':b.box_shadow}">
            <img :src="b.bild.sizes.large" alt="" v-else-if="b.ausrichtung==='over'" class="over" :class="{'shadowed':b.box_shadow}">
            <img :src="b.bild.sizes.large" alt="" v-else :class="{'shadowed':b.box_shadow}">
        </div>
    </div>
</template>
<script>
    export default {
        name: "TwoCols",
        props: ['b']
    }
</script>
<style scoped lang="scss">
    .image {
        &.center, &.right, &.left {
            img {
                width: 300px;
            }
        }
        &.center {
            text-align: center;
        }
        &.left {
            text-align: left;
        }
        &.right {
            text-align: right;
        }
        .full {
            max-width: 100%;
        }
        .over {
            max-width: 100%;
        }
    }
    .blockcontent {
        max-width: 450px;
    }
    .blockcontent, .image {
        @include mobile {

        margin-top: 50px!important;
        }
    }
</style>